import ListCallback from "../../containers/Enquiries/Callback/List";
import EntryCallback from "../../containers/Enquiries/Callback";

import ListHolidays from '../../containers/Enquiries/HolidayEnquiry/List';
import EntryHolidays from '../../containers/Enquiries/HolidayEnquiry';

import ListBuilder from '../../containers/Enquiries/ItineraryBuilder/List';
import EntryBuilder from '../../containers/Enquiries/ItineraryBuilder';

import ListDealEnquiry from '../../containers/Enquiries/DealEnquiry/List';
import EntryDealEnquiry from '../../containers/Enquiries/DealEnquiry';

const enquiryRoutes = [
  {
    path: "/enquiries/callbacks",
    exact: true,
    auth: true,
    component: ListCallback
  },
  {
    path: "/enquiries/callbacks/:type",
    exact: true,
    auth: true,
    component: EntryCallback
  },
  {
    path: "/enquiries/callbacks/:type/:id",
    exact: true,
    auth: true,
    component: EntryCallback
  },
  {
    path: "/enquiries/holiday-enquiries",
    exact: true,
    auth: true,
    component: ListHolidays
  },
  {
    path: "/enquiries/holiday-enquiries/:type",
    exact: true,
    auth: true,
    component: EntryHolidays
  },
  {
    path: "/enquiries/holiday-enquiries/:type/:id",
    exact: true,
    auth: true,
    component: EntryHolidays
  },
  {
    path: "/enquiries/itinerary-builder",
    exact: true,
    auth: true,
    component: ListBuilder
  },
  {
    path: "/enquiries/itinerary-builder/:type",
    exact: true,
    auth: true,
    component: EntryBuilder
  },
  {
    path: "/enquiries/itinerary-builder/:type/:id",
    exact: true,
    auth: true,
    component: EntryBuilder
  },
  {
    path: "/enquiries/deal-enquiry",
    exact: true,
    auth: true,
    component: ListDealEnquiry
  },
  {
    path: "/enquiries/deal-enquiry/:type",
    exact: true,
    auth: true,
    component: EntryDealEnquiry
  },
  {
    path: "/enquiries/deal-enquiry/:type/:id",
    exact: true,
    auth: true,
    component: EntryDealEnquiry
  }
];

export default enquiryRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/enquiries.jsx